import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { compose } from "redux";

import { modalActions } from "../../modal/redux/model";
import { RootState } from "../../redux/reducer";
import {
    ClosableCallToActions,
    MapEngine,
    RenderingTime,
    ResponseParseTime,
    SearchTime,
    commonActions,
} from "./model";

export const hasBgVelocity = () =>
    useSelector((state: RootState) => state.common.hasBgVelocity);

export const useHasBgVelocity = () => {
    const dispatch = useDispatch();

    // const { queryReturn } = useVerifyHasBgVelocityQuery();
    // const hasBgVelocity =
    //     isSnp() ||
    //     queryReturn.data?.verifyHasBgVelocity.status ===
    //         VerifiedAccessKeyStatus.Failed; //return Failed meant velocity has already been added

    // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
    useEffect(() => {
        // if (hasBgVelocity) {
        //     dispatch(
        //         commonActions.setHasBgVelocity({
        //             hasBgVelocity,
        //         })
        //     );
        // }

        dispatch(
            commonActions.setHasBgVelocity({
                hasBgVelocity: true,
            })
        );
    }, [hasBgVelocity]);
};

export const useMapEngines = (): readonly MapEngine[] =>
    useSelector((state: RootState) => state.common.mapEngines);

export const useResponseParseTimes = (): readonly ResponseParseTime[] =>
    useSelector((state: RootState) => state.common.responseParseTimes);

export const useSearchTimestamps = (): readonly SearchTime[] =>
    useSelector((state: RootState) => state.common.searchTimestamps);

export const useRenderingTimes = (): readonly RenderingTime[] =>
    useSelector((state: RootState) => state.common.renderingTimes);

export const useReservedMemory = (): number =>
    useSelector((state: RootState) => state.common.reservedMemory);

export const useClosableCallToActions = (c: keyof ClosableCallToActions) =>
    useSelector((state: RootState) => state.common.closableCallToActions[c]);

/**
 * A custom hook that returns a function to open a modal using Redux dispatch.
 * @returns {Function} A composed function that dispatches the openModal action
 * @example
 * const openModal = useOpenModal();
 * openModal(modalConfig);
 */
export const useOpenModal = () => {
    const dispatch = useDispatch();

    return compose(dispatch, modalActions.openModal);
};

/**
 * Custom hook that returns a function to close a modal via Redux dispatch.
 * This hook composes the dispatch function with the closeModal action.
 *
 * @returns {Function} A composed function that will dispatch the closeModal action when called
 * @example
 * const closeModal = useCloseModal();
 * closeModal(); // Closes the modal
 */
export const useCloseModal = () => {
    const dispatch = useDispatch();

    return compose(dispatch, modalActions.closeModal);
};
